import "./style.css"
import React from "react";

import CVAE from "assets/cv/CV-2025-Abraham-Eishow-Portfolio.pdf";

import Button from "components/Button";
import Container from "components/Container";
import Link from "components/Link";

import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faCircleArrowDown } from "@fortawesome/free-solid-svg-icons";

export default function Navbar() {
	return (
		<React.Fragment>
			<Container containerClass="link-container">
				<Link
					href="https://www.linkedin.com/in/abraham-eishow/"
					linkTitle="Min Linkedin profil"
					iconClass="link-linkedin"
					faIcon={faLinkedin}
				/>
				<Link
					href="https://github.com/Abrei852"
					linkTitle="Min Github sida"
					iconClass="link-github"
					faIcon={faGithub}
				/>
			</Container>
			<Container containerClass="download-container ">
				<a target="_blank" rel="noreferrer" href={CVAE} download="CV-Abraham-Eishow-2025-Portfolio">
					<Button
						title="Ladda ner mitt CV"
						buttonClass="download-button-class"
						containerClass="download-button-container"
						buttonTextClass="download-button-text-class"
						buttonText="MITT CV"
						iconContainerClass="download-button-icon-container-class"
						icon={faCircleArrowDown}
					/>
				</a>
			</Container>
		</React.Fragment>
	);
}
